import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useStateManager } from 'react-select';
import { useNavigate } from 'react-router-dom';

const ReportMisuseForm = () => {



  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const [message, setMessage] = useState('');

  const [formData, setFormData] = useState({
    misuseId: 'HS1234',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmit(true);

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      payload.append(key, value);
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}mycon/report_misuse`, payload
      );
      if (response.data.response === 'success') {
        setFormData({
          misuseId: "",
          subject: "",
          message: ""
        });
        // setMessage(response.data.message);
        navigate('/thankyou');
      }
      if (response.data.response == 'invalid') {
        setMessage(response.data.message);
      }

    } catch (error) {
      console.error("There was an error While Form Submit!", error);
    } finally {
      setIsSubmit(false);
    }



  }

  return (
    <div class="bg-white">
      <div className="container ikjluij">
        <style>
          {
            `
        
        
        .report-heading {
          font-size: 45px;
          font-weight: 500;

        }
          .form-label {
    margin-bottom: 0px;
    color: black;
}

        .ikjluij {
          background: white;
          padding:150px 15px;
        }


        .mb-3{
         margin-bottom:5px !important;}

        .highlight {
          color: #e53d5c;
        }

        .sub-text {
          color: #6c757d;
          font-size: 1rem;
        }

        .report-form-wrapper {
          
          background: #ffffff;
          border: 1px solid #eee;
        }

        .coloju {
          color: black;
        }

        textarea:focus,
        input:focus {
          border-color: #e53d5c;
          box-shadow: 0 0 0 0.2rem rgba(229, 61, 92, 0.25);
        }

        .apnisha {
          box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.075) !important;
          border-radius: 10px;
        }

        .ismy {
          font-size: 20px;
        }

        .bodlis {
          font-weight: 550;
        }
          .redius {
    display: block;
    width: 100%;
    padding: 9.5px 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--bs-body-color);
    background-color: var(--bs-body-bg);
    background-clip: padding-box;
    border: var(--bs-border-width) solid var(--bs-border-color);
    appearance: none;
    border-radius:15px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;}




        `
          }
        </style>
        <div className="text-center mb-4">
          {/* <button className="btn btn-outline-danger btn-sm  bodli">Report</button> */}
          <h3 className="report-heading">
            Report <span className="highlight">Misuse</span>
          </h3>
          <p className="sub-text">
            Most Trusted And Premium Matrimony Service In The World.
          </p>
        </div>

        <div className="report-form-wrapper mx-auto p-4 shadow-sm apnisha center-align-items  col-md-6">
          {/* <h5 className="mb-3 text-uppercase fw-bold">Report</h5> */}
          <h6 className="text-start fw-semibold text-dark ismy mb-2">
            Send Your Enquiry <span className="text-danger fw-semibold ">Now</span>
          </h6>

          <form method="post" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="misuseId" className="form-label coloju bodli">Misuse ID:</label>
              <input onChange={handleChange} type="text" className="redius" name="misuseId" placeholder={formData.misuseId}  required/>
            </div>

            <div className="mb-3">
              <label htmlFor="subject" className="form-label coloju bodli">Subject:</label>
              <input type="text" className="redius" name="subject" placeholder="Enter your phone"
                onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label htmlFor="message" className="form-label coloju bodli">Message:</label>
              <textarea className="redius" name="message" placeholder="Enter message" rows="4" onChange={handleChange}
                required></textarea>
            </div>



            <div className="d-grid mt-3">
              {!isSubmit &&
                <button disabled={isSubmit} type="submit" className="btn btn-danger bodlis">Send Report</button>}
              {isSubmit &&
                <button type="button" disabled={isSubmit} className="btn btn-danger bodlis">Sending...</button>}
            </div>


            {message &&
              <div class="border alert alert-danger mt-4"><strong>{message}</strong></div>
            }


          </form>
        </div>
      </div>
    </div>
  );
};

export default ReportMisuseForm;